<template>
    <form @input="submit">
        <div class="settings-layout details-layout">
            <h4>Bank Account Details</h4>
            <hr/>
            <p>Insert your bank account details to receive your LITT payments</p>
            <div>
                <div class="form-group">
                    <label for="">Account Name</label>
                    <input type="text" name="holder_name" class="required custom-msg-display holder_name" v-model="accountName" @blur="v$.accountName.$touch()">
                    <FormError :validationStatus="v$.accountName"/>
                </div>
                <div class="form-group">
                    <label for="">bsb</label>
                    <input type="text" name="bsb" class="required custom-msg-display bsb digits" v-model="bsb" @blur="v$.bsb.$touch()">
                    <FormError :validationStatus="v$.bsb"/>
                    <p v-if="v$.bsb.$error && v$.bsb.only6Digits.$invalid" class="help-block">BSB needs to be 6 digits</p>
                </div>
                <div class="form-group">
                    <label for="">Account No.</label>
                    <input type="text" name="account_number" class="required custom-msg-display account_number digits" v-model="accountNo" @blur="v$.accountNo.$touch()">
                    <FormError :validationStatus="v$.accountNo"/>
                </div>
            </div>
            <h4>LITT Pay</h4>
            <hr/>
            <p>Your LITT transaction fees are 10% inclusive of customer cashback of 5%.</p>
        </div>
    </form>
</template>

<script>
import FormError from './../../FormError.vue';
import { required, minLength, maxLength, numeric } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';

const only6Digits = (value) => {
    return value.trim().length === 6;
}

export default {
    setup(){
        return { v$: useVuelidate() }
    },
    name: "LITTPay",
    components: {FormError},
    data(){
        return{
            accountName: "",
            bsb: "",
            accountNo: "",
        }
    },
    methods:{
           submit(){
                this.$emit('update', {
                    data:{
                        accountName: this.accountName,
                        bsb: this.bsb,
                        accountNo: this.accountNo,
                    },
                    valid: !this.v$.$invalid
                })
        },
    },
    validations:{
        accountName: {required, minLength: minLength(2)},
        bsb: {required, numeric, only6Digits},
        accountNo: {required, numeric, minLength: minLength(8), maxLength: maxLength(10)},
    }
}
</script>